<div class="w-full flex flex-col gap-[0.75rem] px-[0.75rem] sm:px-[1rem] pb-3 sm:pb-(--date-selection-reserved-height-for-sm-and-md) lg:pb-0"
  [gcElementWidthClass]=""
  [gcElementWidthClassIsActive]="!floatingPopupService.isMobileMode()">
  @let data = correlation();

  @if (data) {
    <gc-ld-correlation-type-icon-with-quality [correlation]="data" [primaryColor]="true"></gc-ld-correlation-type-icon-with-quality>

    <div class="flex flex-col items-start">
      <div class="grid
        grid-cols-[1fr]
        md:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]
        lg:grid-cols-[1fr]
        gap-[0.25rem]
        md:gap-[2.5rem]
        lg:gap-[0.25rem]
        [.is-md_&]:!grid-cols-[minmax(0,1fr)_minmax(0,1fr)]
        [.is-md_&]:!gap-[2.5rem]
        w-full
        max-w-[62.5rem]">
        <div class="flex flex-col gap-[0.25rem] items-start">
          <gc-label-value-presentation [label]="'@@shared-logger1__text' | translate">{{logger1()}}</gc-label-value-presentation>

          <gc-label-value-presentation [label]="'@@shared-logger2__text' | translate">{{logger2()}}</gc-label-value-presentation>

          <gc-label-value-presentation [label]="'@@shared-sound-signal-start__text' | translate">{{soundSignalStartAt()}}</gc-label-value-presentation>

          <gc-label-value-presentation [label]="'@@shared-distanceL1__text' | translate">{{distanceL1()}}</gc-label-value-presentation>

          <gc-label-value-presentation [label]="'@@shared-distanceL2__text' | translate">{{distanceL2()}}</gc-label-value-presentation>

          <gc-label-value-presentation [label]="'@@shared-center-distance__text' | translate">{{centerDistance()}}</gc-label-value-presentation>
        </div>

        <div class="flex flex-col gap-[0.25rem] items-start">
          <gc-label-value-presentation [label]="'@@shared-pipe-length__text' | translate">{{pipeLength()}}</gc-label-value-presentation>

          <gc-label-value-presentation [label]="'@@shared-pipe-setup__text' | translate">
            <gc-ld-correlation-pipe-provided-icon [pipeProvided]="!!data.pipeProvided"></gc-ld-correlation-pipe-provided-icon>
          </gc-label-value-presentation>

          <gc-label-value-presentation [label]="'@@shared-latitude-longitude__text' | translate">{{latitudeLongitude()}}</gc-label-value-presentation>

          @let coordinatesLabelText = coordinatesLabel();

          <gc-label-value-presentation [label]="coordinatesLabelText.key | translate: coordinatesLabelText.params">{{coordinates()}}</gc-label-value-presentation>

          @let isCommentExist = !!data.comment;

          <gc-label-value-presentation [label]="'@@shared-comments' | translate" [stacked]="true">
            @if (isCommentExist) {
              <gc-comment-card
                [authorName]="commentAuthor()"
                [authorDate]="commentModifiedAt()"
                [message]="comment()"
                [showBorder]="true"
                [showBorder]="true"
                [showReadMoreButton]="true"
                [truncateMessage]="true"
                (readMore)="changeToCommentTab()">
              </gc-comment-card>
            } @else {
              <gc-comment-card-no-data
                [addPermissions]="[PermissionName.LeakDetection_Write_Comments]"
                (add)="changeToCommentTab()">
              </gc-comment-card-no-data>
            }
          </gc-label-value-presentation>
        </div>
      </div>
    </div>

    <div *ngxPermissionsOnly="[PermissionName.LeakDetection_Read_DeveloperColumns]" class="flex flex-col items-start border-t border-(--p-blue-50) mb-4 pt-3">
      <div class="grid
        grid-cols-[1fr]
        md:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]
        lg:grid-cols-[1fr]
        gap-[0.25rem]
        md:gap-[2.5rem]
        lg:gap-[0.25rem]
        [.is-md_&]:!grid-cols-[minmax(0,1fr)_minmax(0,1fr)]
        [.is-md_&]:!gap-[2.5rem]
        w-full
        max-w-[62.5rem]">
        <div class="flex flex-col gap-[0.25rem] items-start">
          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-correlations-consistency__label' | translate">{{consistency()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-correlations-max-time__label' | translate">{{maxTime()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-correlations-maximum__label' | translate">{{maximum()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-correlations-sound-velocity__label' | translate">{{soundVelocity()}}</gc-label-value-presentation>
        </div>

        <div class="flex flex-col gap-[0.25rem] items-start">
          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-correlations-overlap__label' | translate">{{overlap()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-correlations-corr-length__label' | translate">{{corrLength()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-correlations-delay-max__label' | translate">{{delayMax()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-correlations-why-unsynchronized__label' | translate">{{whyUnsynchronized()}}</gc-label-value-presentation>
        </div>
      </div>
    </div>
  }
</div>
